export default __webpack_public_path__ + "static/media/Background_00075.7a6a043d.png";